"use client";

import { Button } from "@/components/ui/button";
import { useStorageQuery } from "../../../hooks/storageQueryProvider";
import { ChevronRight } from "lucide-react";
import { t } from "@/lib/localization";

export default function StorageTitle() {
    const {
        parentFolder,
        changeParentFolder,
        currentStoragePath,
        loadingCurrentStoragePath,
    } = useStorageQuery();

    const back = () => {
        if (!currentStoragePath) return;

        if (currentStoragePath.length === 0) {
            changeParentFolder(null);
        } else {
            changeParentFolder(
                currentStoragePath[currentStoragePath.length - 1]
            );
        }
    };

    const title = parentFolder ? parentFolder.name : t("storage.header.title");

    return (
        <div className="flex flex-row gap-2 items-center max-w-[400px]">
            {parentFolder && (
                <Button
                    onClick={back}
                    disabled={loadingCurrentStoragePath}
                    size="icon"
                    variant="outline"
                    className="shrink-0"
                >
                    <ChevronRight className="size-4 ltr:rotate-180" />
                </Button>
            )}
            <h2
                title={title}
                className="text-3xl truncate font-bold leading-tight tracking-tight text-gray-900"
            >
                {title}
            </h2>
        </div>
    );
}
